import { useState } from "react"
import { css } from "@emotion/react"
import { Pledge, GivingPerson } from "../types"
import { Icon, Loading } from "source/shared/components"
import PledgeDetails from "./PledgeDetails"
import InfiniteScroll from "react-infinite-scroller"
import { usePledges } from "../hooks/usePledges"

export default function ConcludedPledgesList() {
  const [showConcludedPledges, setShowConcludedPledges] =
    useState<boolean>(false)

  const { data, fetchNextPage, hasNextPage, isFetching } = usePledges({
    current: false,
  })

  const concludedPledges: Pledge[] =
    data.pages.flatMap((page) => page.pledges) || []
  const jointGiver: GivingPerson | null = data.pages[0]?.jointGiver || null
  const totalCount = data.pages[0]?.meta.total_count
  const loadMore = () => !isFetching && fetchNextPage()

  const handleConcludedPledgesToggle = (event: {
    currentTarget: { open: boolean }
  }) => setShowConcludedPledges(event.currentTarget.open)

  return (
    <details
      onToggle={handleConcludedPledgesToggle}
      open={showConcludedPledges}
      className="d-f fd-c g-1"
      css={css`
        &[open] .pledges-list {
          max-height: 100%;
        }
      `}
    >
      <summary
        className="d-f ai-c jc-sb"
        css={css`
          cursor: pointer;
        `}
      >
        <div className="d-f g-1 ai-c">
          <span className="fw-600 fs-13 tt-u c-tint2">Concluded pledges</span>
          <span
            className="fs-4 fw-600"
            css={css`
              background-color: var(--color-tint3);
              color: var(--color-tint10);
              border-radius: 40px;
              padding-right: 10px;
              padding-left: 10px;
            `}
          >
            {totalCount}
          </span>
        </div>
        <Icon
          symbol={`general#${showConcludedPledges ? "down" : "up"}-chevron`}
          aria-hidden="true"
          css={css`
            height: 12px;
            width: 12px;
            fill: var(--color-static-gray45);
          `}
        />
      </summary>
      <div
        className="pledges-list d-f fd-c g-2"
        css={css`
          max-height: 0px;
          overflow: hidden;
          transition: max-height 0.3s ease;
        `}
      >
        <InfiniteScroll
          hasMore={hasNextPage}
          loadMore={loadMore}
          loader={<Loading key="loading" />}
          className="d-f fd-c g-2"
        >
          {concludedPledges.map((pledge) => (
            <PledgeDetails
              key={pledge.id}
              jointGiver={jointGiver}
              pledge={pledge}
              pledgeCampaign={pledge.pledge_campaign}
              fund={pledge.fund}
              showFullDetails={true}
            />
          ))}
        </InfiniteScroll>
      </div>
    </details>
  )
}
